import { render, staticRenderFns } from "./leftButton.vue?vue&type=template&id=79aebcb8&scoped=true"
import script from "./leftButton.vue?vue&type=script&lang=js"
export * from "./leftButton.vue?vue&type=script&lang=js"
import style0 from "./leftButton.vue?vue&type=style&index=0&id=79aebcb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aebcb8",
  null
  
)

export default component.exports